import { render, staticRenderFns } from "./CSVCodes.vue?vue&type=template&id=bc57da10&"
import script from "./CSVCodes.vue?vue&type=script&lang=js&"
export * from "./CSVCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports